import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";

export const useGetPrimeiroAcesso = (token: string) => {

  return useFetch<string>({
    key: ["primeiro-acesso", token],
    url: `${api.usuario.primeiroAcesso}/${token}`,
    enabled: !!token,
  });
};
